import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import { type SearchParams, useFetchBusinessSearch } from './useFetchBusinessSearch'

export const queryKeys = createQueryKeys('business-search', {
  search: ({ params }: { params: ComputedRef<SearchParams> }) => ({
    queryKey: [{ params }],
  }),
})

const search = ({
  params,
  useQueryOptions,
}: {
  params: ComputedRef<SearchParams>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { search } = useFetchBusinessSearch()

  return useQuery({
    ...queryKeys.search({
      params,
    }),
    queryFn: () => search({ params: toValue(params) }),
    ...useQueryOptions,
  })
}

export const useQueryBusinessSearch = {
  search,
}
